<nav
  class="main-nav-list"
  [style.width]="this.isSideMenuOpen() ? '75px' : '97%'"
>
  <ul class="routes-list">
    @for (sideMenuItem of sideMenuItems; track $index) {
    <li class="route">
      <a
        class="router-link"
        [routerLink]="[sideMenuItem.route('')]"
        [relativeTo]="route"
        [ngClass]="{ active: this.isCurrentRouteActive(sideMenuItem) }"
      >
        <img
          class="router-image"
          [src]="this.getSideMenuItemIcon(sideMenuItem)"
          [alt]="sideMenuItem.alt"
        />
        <span class="router-text" [hidden]="this.isSideMenuOpen()">{{
          sideMenuItem.translationPath | translate
        }}</span>
      </a>
    </li>
    }
  </ul>
</nav>
